import { InjectionToken } from '@angular/core';

export interface TenantConfig {
  subdomain: string; // Matches backend tenant.subdomain, e.g., 'abz'

  urls: {
    staging: string[]; // e.g., ['abz.staging.flink.coop']
    production: string[]; // e.g., ['wink.abz.ch', 'abz.flink.coop']
  };

  nativeApp?: {
    bundleId: string;
    appName: string;
  };
}

export const APP_TENANT_CONFIG = new InjectionToken<TenantConfig[]>(
  'APP_TENANT_CONFIG'
);
